import ReactDOM from 'react-dom/client';
import { AppProviders } from './app/providers';
import App from './app/App';
import './index.css';

const storedTheme = localStorage.getItem('fleet.shell.theme');
const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
if (storedTheme === 'dark' || (!storedTheme && prefersDark)) {
  document.documentElement.classList.add('dark');
}

// Con VITE_MOCK_API=true le chiamate /api le serve MSW (src/mocks), senza backend.
async function startMockApi() {
  if (import.meta.env.VITE_MOCK_API !== 'true') return;
  const { worker } = await import('./mocks/browser');
  await worker.start({ onUnhandledFrame: 'bypass' });
}

startMockApi().then(() =>
  ReactDOM.createRoot(document.getElementById('root')).render(
    <AppProviders>
      <App />
    </AppProviders>
  )
);
